import { render, staticRenderFns } from "./InfoThree.vue?vue&type=template&id=455de585&"
import script from "./InfoThree.vue?vue&type=script&lang=js&"
export * from "./InfoThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455de585')) {
      api.createRecord('455de585', component.options)
    } else {
      api.reload('455de585', component.options)
    }
    module.hot.accept("./InfoThree.vue?vue&type=template&id=455de585&", function () {
      api.rerender('455de585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/info-tabs/InfoThree.vue"
export default component.exports